import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {AssetGroupService} from '../../../../_services/asset-group-service';

@Component({
  selector: 'acabim-admin-add-asset-group',
  templateUrl: './add-asset-group.component.html',
  styleUrls: ['./add-asset-group.component.scss']
})
export class AddAssetGroupComponent implements OnInit {
  @Output() completed = new EventEmitter<string>();
  public loading = false;
  public assetGroupForm: FormGroup | null = null;
  private _currentProcess: Subscription = new Subscription();

  constructor(
      private readonly logger: NGXLogger,
      private readonly assetGroupService: AssetGroupService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy():void {
    this._currentProcess.unsubscribe();
  }

  private initForm(): void {
    this.assetGroupForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      description: new FormControl(null)
    });
    this.loading = false;
  }

  onSubmit(): void {
    this.loading = true;
    if (this.assetGroupForm && this.assetGroupForm.value) {
      this.upsertContactType();
    }
  }

  onCancel(): void {
    this.completed.emit('cancelled');
  }

  private upsertContactType(): void {
    if (this.assetGroupForm && this.assetGroupForm.value) {
      this.logger.debug('[AddAssetGroupComponent] Adding new asset type');
      this.loading = true;
      this._currentProcess = this.assetGroupService.upsertAssetGroup(
          this.assetGroupForm.value.name,
          this.assetGroupForm.value.description
      ).subscribe(newAssetGroup => {
        this.logger.debug('[AddAssetGroupComponent] Asset group added successfully: ', newAssetGroup.id);
        this.initForm();
        this.completed.emit('added');
        this.loading = false;
        console.log('Upsert: added');
      }, (error: any) => {
        this.logger.debug('[AddAssetGroupComponent] Asset group failed to add');
        this.logger.error(error);
        this.loading = false;
      });
    }
  }
}
